import { useStorage } from '@vueuse/core'

const collapsed = useStorage('sidebar-collapsed', true)

export function useSidebar() {
  return { collapsed }
}
